import Alert from 'svg/Alert';
import CloseIcon from 'svg/CloseIcon';
import Button from 'components/Button';
import Modal from 'components/modals/Modal';

export interface SkipReflectionModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleSkipReflection: () => void;
  loading: boolean;
  playerName?: string;
}

const SkipReflectionModal = ({
  isOpen,
  handleClose,
  handleSkipReflection,
  loading,
  playerName,
}: SkipReflectionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      classNameMaxWidth="md:max-w-[40rem] xs:max-w-md"
    >
      <div className="p-6">
        <div className="mx-5 my-2 flex flex-row justify-end">
          <button
            className="w-6 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
            type="button"
            onClick={handleClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="xs:my-7 md:my-3">
            <Alert />
          </div>
          <h3 className="typography-product-display text-center text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Skip Recap
          </h3>
          <p className="typography-product-body mx-8 text-center text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary xs:mb-48 md:mb-40 md:mt-2">
            Are you sure you want to skip the recap for{' '}
            {playerName ? `"${playerName}"` : 'this player'}?
          </p>

          <header className="fixed bottom-0 left-0 right-0 z-20 flex items-center justify-center border-color-border-input-lightmode bg-white py-4 xs:flex-col xs:gap-4 xs:px-4 md:h-[6.5rem] md:flex-row md:gap-6 md:border-t md:px-10">
            <div className="w-full">
              <Button variant="inverted" size="lg" onClick={handleClose}>
                Cancel
              </Button>
            </div>
            <div className="w-full">
              <Button variant="primary" size="lg" onClick={handleSkipReflection} loading={loading}>
                {loading ? 'Skipping...' : 'Skip Recap'}
              </Button>
            </div>
          </header>
        </div>
      </div>
    </Modal>
  );
};

export default SkipReflectionModal;
